import { render, staticRenderFns } from "./ASC_Trending.vue?vue&type=template&id=cecf672c&scoped=true&"
import script from "./ASC_Trending.vue?vue&type=script&lang=js&"
export * from "./ASC_Trending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecf672c",
  null
  
)

export default component.exports